define('widgets/olark/olarkSpecificSession',[],function () {

    function OlarkSpecificSession(wrappedPlayer) {
        return function () {

            var player = wrappedPlayer.peek(),
                username = player.adventurer.casumoName,
                contactInfo = player.contactInfo,
                fullName = [
                    contactInfo.name.firstName(),
                    contactInfo.name.lastName()
                    ].join(' '),
                phoneNumber = [
                    contactInfo.phoneNumber.prefix(),
                    contactInfo.phoneNumber.number()
                ].join(' '),
                email = contactInfo.email();

            return {
                'username': username,
                'fullName': fullName,
                'phoneNumber': phoneNumber,
                'email': email
            };
        }
    }

    return OlarkSpecificSession;
});
